import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const PlayIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "PlayIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}

      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.9559 2H16.3117L15.5099 3.75266L16.3117 5.50533H13.1243V6.67985H16.715L17.4497 11.4795H18.8981L20.2125 22H15.2275L9.85267 22L4.86768 22L6.1821 11.4795H7.63042L8.36509 6.67985H11.9559V2ZM13.1243 3.16844V4.33689H14.4923L14.225 3.75266L14.4923 3.16844H13.1243ZM8.45054 12.648H7.21365L6.19119 20.8315H9.85267V18.927C9.85267 17.4428 11.0559 16.2396 12.5401 16.2396C14.0243 16.2396 15.2275 17.4428 15.2275 18.927V20.8315H18.889L17.8665 12.648H16.6296V14.9455H13.1243V12.648H11.9559V14.9455H8.45054V12.648ZM16.2677 11.4795L15.7118 7.8483H9.36829L8.81247 11.4795H9.61898V13.7771H10.7874V11.4795H14.2928V13.7771H15.4612V11.4795H16.2677ZM14.0591 20.8315V18.927C14.0591 18.0881 13.379 17.408 12.5401 17.408C11.7012 17.408 11.0211 18.0881 11.0211 18.927V20.8315H14.0591Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default PlayIcon;
